import { computed } from "vue";
import useCompanyInfoData from "./useCompanyInfoData";

/**
 * Contact phone from `api/company-info` (first entry of `telephones`), digits
 * only — the footers render it as `+{phone}` and link `tel:{phone}`, same shape
 * as the config `public.phone`. Falls back to the config value while the
 * backend has no telephone, so existing clients keep working.
 */
export default function useCompanyPhone() {
  const config = useRuntimeConfig() as unknown as RuntimeConfiguration;
  const data = useCompanyInfoData();

  return computed<string>(() => {
    const fromBackend = String(data.value?.telephones?.[0] ?? "").replace(
      /\D/g,
      "",
    );
    return fromBackend || String(config.public.phone ?? "");
  });
}
